export default __webpack_public_path__ + "68b8b5cc174bf1921e7882d2e0e44961.pdf";